export default __webpack_public_path__ + "static/media/checkmark-rounded-61CEF7.90dc329b.svg";